<template>
<div class="Testpaper padding-20 bgc box-shadow">
    <!--<keep-alive>-->
        <router-view></router-view>
    <!--</keep-alive>-->
</div>
</template>

<script>
export default {
    name: 'Testpaper',
    data() {
        return {}
    },
    mounted() {},
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.Testpaper {
    min-width: 1100px;
    font-family: PingFangSC-Regular,PingFang SC;
}
</style>
